import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { selectSettingsPermissionsMicrophone } from '@/store/features/settings/selectors';
import { showUIAlert } from '@/store/features/ui/slice';
import { AlertActions, AlertTypes } from '@/store/features/ui/types';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

export const useMicrophoneStatus = () => {
  const {t} = useTranslation();

  const dispatch = useAppDispatch();
  const status = useAppSelector(selectSettingsPermissionsMicrophone);

  useEffect(() => {
    if (status !== 'granted') {
      dispatch(
        showUIAlert({
          title: t('microphone_access_needed'),
          message: t('microphone_access_message'),
          type: AlertTypes.error,
          action: AlertActions.navigateHome,
        }),
      );
    }
  }, [dispatch, status, t]);
};
